class Modals {
    constructor() {
        this.fixBackdrop();
    }

    /**
     * An update to bootstrap forced the modal-backdrop to be
     * placed at the bottom of the DOM, meaning it had a higher
     * zIndex than the entire app container. Moving it into
     * the modal container fixes this.
     */
    fixBackdrop() {
        $(document).on('show.bs.modal', '.modal', ({ currentTarget }) => {
            setTimeout(() => {
                const $backdrop = $('.modal-backdrop');
                $backdrop.appendTo($(currentTarget));
                // For some reason backdrop click events are broken in this version of bootstrap?
                // Let's reimplement
                $backdrop.on('click', ({ currentTarget }) => {
                    $(currentTarget).closest('.modal').modal('hide');
                });
            }, 0);
        });
    }
}

export default new Modals;
